<script>
  import { slide } from 'svelte/transition';
  import WarningIcon from 'carbon-icons-svelte/lib/WarningAlt16';

  import { criticalWarningsStore } from '../stores';

  let warningsList = [];

  function getWarningList(warnings = {}) {
    return Object.values(warnings).reduce((acc, warning) => {
      if (warning?.text) {
        acc.push(warning.text);
      }
      return acc;
    }, []);
  }

  $: warningsList = getWarningList($criticalWarningsStore);
</script>

{#if warningsList.length > 0}
  <div class="critical-warnings-header" role="status" aria-live="polite" transition:slide={{ delay: 1000, duration: 220, axis: 'y' }}>
    <WarningIcon />
    <ul>
      {#each warningsList as warning}
        <li>{warning}</li>
      {/each}
    </ul>
  </div>
{/if}

<style>
  .critical-warnings-header {
    position: relative;
    background: var(--cds-support-warning-inverse);
    top: 3rem;
    padding: 0.5rem 1.5rem;
    color: #161616;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    box-shadow: inset 0px 4px 4px -2px #000;
    border-bottom: 2px inset #a98504;
  }

  .critical-warnings-header :global(svg) {
    flex-shrink: 0;
  }

  .critical-warnings-header ul {
    list-style: none;
    font-weight: 600;
  }
</style>
